import {
    selectedPrescripteursSelector,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';

export const useCurrentPrescriber = () => {
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);

    if (!prescripteur) {
        return undefined;
    }

    return prescripteur;
};
